// extracted by mini-css-extract-plugin
var _1 = "src-components-HomePage-HomePage__bodyBackgroundColorOverride--aTRtTKIZTHbFSwuqwFen";
var _2 = "src-components-HomePage-HomePage__createNoteButton--cueySWGRNIyYqZsI3ldF";
export { _1 as "bodyBackgroundColorOverride", _2 as "createNoteButton" }
